import { Capacitor } from '@capacitor/core';
import { Filesystem, Directory } from '@capacitor/filesystem';
import { Share } from '@capacitor/share';

const token = () => localStorage.getItem('token');

function blobToBase64(blob: Blob): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      const base64data = (reader.result as string).split(',')[1];
      resolve(base64data);
    };
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
}

/**
 * Descarga un archivo protegido (con token) y lo entrega al usuario.
 * En el navegador normal: dispara la descarga estándar del navegador.
 * Dentro de la app (Android/iOS): lo guarda temporalmente y abre el
 * diálogo nativo de "Abrir con / Compartir".
 */
export async function descargarArchivo(url: string, nombreArchivo: string) {
  try {
    const r = await fetch(url, { headers: { Authorization: `Bearer ${token()}` } });
    if (!r.ok) { alert('No se pudo generar el archivo'); return; }
    const blob = await r.blob();

    if (Capacitor.isNativePlatform()) {
      const base64 = await blobToBase64(blob);
      const resultado = await Filesystem.writeFile({
        path: nombreArchivo,
        data: base64,
        directory: Directory.Cache,
      });
      await Share.share({
        title: nombreArchivo,
        url: resultado.uri,
        dialogTitle: 'Abrir o compartir archivo',
      });
    } else {
      const blobUrl = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = blobUrl;
      a.download = nombreArchivo;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(blobUrl);
    }
  } catch (e) {
    console.error('Error descargando el archivo', e);
    alert('No se pudo generar el archivo');
  }
}
